export default __webpack_public_path__ + "static/media/dicklogo.9f1ffd25.png";